<ejs-grid #grid
          class="grid-with-toolbar"
          width="100%"
          rowHeight="38"
          [dataSource]="blacklist"
          [editSettings]="editSettings"
          [searchSettings]="searchOptions"
          (actionComplete)="actionComplete($event)"
          (actionBegin)="actionBegin($event)">
  <ng-template #toolbarTemplate
               let-data>
    <ejs-toolbar>
      <e-items>
        <e-item text="{{ 'i18n.domain.administration.tariff-details.blacklist-tab.blacklist-add' |  translate }}"
                prefixIcon="e-icons icon-add"
                (click)="onAdd()"></e-item>
      </e-items>
    </ejs-toolbar>
  </ng-template>
  <e-columns>
    <e-column field="id"
              [visible]="false"
              headerText="id"
              [isPrimaryKey]="true"></e-column>
    <e-column field="countryCode"
              headerText="{{'i18n.domain.administration.tariff-details.blacklist-tab.fields.countryCode' | translate}}"
              clipMode="EllipsisWithTooltip"></e-column>
    <e-column field="controlPlateType"
              headerText="{{'i18n.domain.administration.tariff-details.blacklist-tab.fields.controlPlateType' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #filterItemTemplate let-data>{{formatControlPlateType(data) | translate}}</ng-template>
      <ng-template #template let-data>
        {{formatControlPlateType(data) | translate}}
      </ng-template>
    </e-column>
    <e-column field="controlPlateNumber"
              headerText="{{'i18n.domain.administration.tariff-details.blacklist-tab.fields.controlPlateNumber' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span class="text-uppercase">{{data.controlPlateNumber | translate}}</span>
      </ng-template>
    </e-column>
    <e-column headerText=""
              [commands]="commands"
              width="120px"></e-column>
  </e-columns>
  <ng-template #editSettingsTemplate
               let-data>
    <app-blacklist-form [blacklistForm]="gridEditForm"></app-blacklist-form>
  </ng-template>
</ejs-grid>
